import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { localizationEnabled } from "@redotech/redo-team-common/localization/settings";

/**
 * Whether the current team may author flow text translations. The RPCs enforce
 * the same setting server-side.
 */
export function useFlowTextTranslationsEnabled(): boolean {
  const team = useRequiredContext(TeamContext);
  return localizationEnabled(team.settings.localization);
}
